import React from "react";
import { getUserId } from '../../services/auth.service';

const ImageUploadWidget = ({ buttonMessage, onUpload }) => {
  const uploadWidget = window.cloudinary.createUploadWidget(
    {
      cloudName: "myhellohello",
      uploadPreset: "mojcxr67",
      // autoMinimize: true,
      // singleUploadAutoClose: true,
      cropping: true,
      croppingCoordinatesMode: 'custom',
      croppingShowDimensions: true,
      croppingAspectRatio: 1,
      buttonClass: "btn btn-block btn-primary",
      sources: ["local", "camera"],
      folder: getUserId(),
      styles: {
        palette: {
          window: "#000000",
          windowBorder: "#FFC000",
          tabIcon: "#FFFFFF",
          menuIcons: "#FFFFFF",
          textDark: "#000000",
          textLight: "#FFC000",
          link: "#FFC000",
          action: "#FFC000",
          inactiveTabIcon: "#FFFFFF",
          error: "#F44235",
          inProgress: "#FFC000",
          complete: "#FFC000",
          sourceBg: "#000000"
        }
      }
    },
    (error, result) => {
      if (!error && result && result.event === "success") {
        onUpload(result.info);
      }
    }
  );

  return (
    <button
      type="button"
      className="btn btn-block btn-primary"
      onClick={() => uploadWidget.open()}
    >
      {buttonMessage}
    </button>
  );
};

export default ImageUploadWidget;

// https://cloudinary.com/documentation/upload_widget#upload_widget_options

/*
Returned info after upload:

bytes: 8978
created_at: "2019-03-26T20:40:14Z"
etag: "d52a1453e4ac2f3cc3abdb39842b2be7"
format: "jpg"
height: 168
original_extension: "jpeg"
original_filename: "rick"
path: "v1553632814/y81zwda9amw9ueh7amxx.jpg"
placeholder: false
public_id: "y81zwda9amw9ueh7amxx"
resource_type: "image"
secure_url: "https://res.cloudinary.com/dragasteff/image/upload/v1553632814/y81zwda9amw9ueh7amxx.jpg"
signature: "62e3e2550c57935b2efb21e93693a1c5d441bb86"
tags: []
thumbnail_url: "https://res.cloudinary.com/dragasteff/image/upload/c_limit,h_60,w_90/v1553632814/y81zwda9amw9ueh7amxx.jpg"
type: "upload"
url: "http://res.cloudinary.com/dragasteff/image/upload/v1553632814/y81zwda9amw9ueh7amxx.jpg"
version: 1553632814
width: 299
*/



// WEBPACK FOOTER //
// ./src/components/ImageUploadWidget/ImageUploadWidget.jsx